import { isNullOrUndefined } from 'util';

export default class QuoteAcceptanceInformation {
  constructor(json) {
    if (!isNullOrUndefined(json)) {
      Object.keys(json).map((key) => (this[key] = json[key]));
      return;
    }

    this.poNumber = '';
    this.hasAttachment = false;
    this.notes = '';
    this.fileKey = '';
    this.fileName = '';
  }
}
